import React, { useCallback } from "react"
import RelatedDocumentsAndProcessesFields from "src/forms/components/RelatedDocumentsAndProcessesFields"

export default function RelatedDocumentsAndProcessesStep({
  formData,
  onChange,
  disabledRelatedDocuments,
  disabledRelatedProcesses,
  initialProcessesSlugs,
}) {
  const handleDocumentsChange = useCallback(
    (documents) => {
      onChange({
        target: {
          name: "relatedDocuments",
          value: documents,
        },
      })
    },
    [onChange]
  )

  const handleProcessesChange = useCallback(
    (processes) => {
      onChange({
        target: {
          name: "relatedProcesses",
          value: processes,
        },
      })
    },
    [onChange]
  )

  return (
    <RelatedDocumentsAndProcessesFields
      relatedDocuments={formData.relatedDocuments.value}
      relatedProcesses={formData.relatedProcesses.value}
      onDocumentsChange={handleDocumentsChange}
      onProcessesChange={handleProcessesChange}
      disabledRelatedDocuments={disabledRelatedDocuments}
      disabledRelatedProcesses={disabledRelatedProcesses}
      initialProcessesSlugs={initialProcessesSlugs}
    />
  )
}
